import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type LoadProvingDocumentsQueryVariables = {
  id: Types.Scalars['ID']
};


export type LoadProvingDocumentsQuery = (
  { __typename?: 'Query' }
  & { proving: Types.Maybe<(
    { __typename?: 'Proving' }
    & Pick<Types.Proving, '_id'>
    & { participants: Types.Maybe<Array<(
      { __typename?: 'Participant' }
      & Pick<Types.Participant, '_id' | 'dateFrom' | 'dateTo'>
      & { person: Types.Maybe<(
        { __typename?: 'User' }
        & Pick<Types.User, '_id' | 'name' | 'firstName' | 'lastName'>
      ) | (
        { __typename?: 'Worker' }
        & Pick<Types.Worker, '_id' | 'name' | 'firstName' | 'lastName'>
      )>, unknownPerson: Types.Maybe<(
        { __typename?: 'UnknownPerson' }
        & Pick<Types.UnknownPerson, 'isUnknown' | 'personType' | 'surName' | 'firstName' | 'department'>
      )> }
    )>>, documents: Types.Maybe<Array<(
      { __typename?: 'ProvingDocument' }
      & Pick<Types.ProvingDocument, '_id' | 'uri' | 'name' | 'type' | 'participantId' | 'block'>
    )>> }
  )> }
);

export type AddProvingDocumentsMutationVariables = {
  provingId: Types.Scalars['String'],
  input: Array<Types.Maybe<Types.ProvingDocumentAdd>>
};


export type AddProvingDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { addProvingDocuments: Array<Types.Maybe<(
    { __typename?: 'ProvingDocument' }
    & Pick<Types.ProvingDocument, '_id' | 'uri' | 'name' | 'type' | 'participantId'>
  )>> }
);

export type UpdateProvingDocumentsMutationVariables = {
  provingId: Types.Scalars['String'],
  input: Array<Types.Maybe<Types.ProvingDocumentUpdate>>
};


export type UpdateProvingDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { updateProvingDocuments: Array<Types.Maybe<(
    { __typename?: 'ProvingDocument' }
    & Pick<Types.ProvingDocument, '_id' | 'uri' | 'name' | 'type' | 'block' | 'participantId'>
  )>> }
);

export type DeleteProvingDocumentsMutationVariables = {
  provingId: Types.Scalars['String'],
  documentIds: Array<Types.Scalars['String']>
};


export type DeleteProvingDocumentsMutation = (
  { __typename?: 'Mutation' }
  & { deleteProvingDocuments: Array<Types.Maybe<(
    { __typename?: 'ProvingDocument' }
    & Pick<Types.ProvingDocument, '_id'>
  )>> }
);

export const LoadProvingDocumentsDocument = gql`
    query LoadProvingDocuments($id: ID!) {
  proving(id: $id) {
    _id
    participants {
      _id
      dateFrom
      dateTo
      person {
        _id
        name
        firstName
        lastName
      }
      unknownPerson {
        isUnknown
        personType
        surName
        firstName
        department
      }
    }
    documents {
      _id
      uri
      name
      type
      participantId
      block
    }
  }
}
    `;

    export function useLoadProvingDocumentsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LoadProvingDocumentsQuery, LoadProvingDocumentsQueryVariables>) {
      return ApolloReactHooks.useQuery<LoadProvingDocumentsQuery, LoadProvingDocumentsQueryVariables>(LoadProvingDocumentsDocument, baseOptions);
    };
      export function useLoadProvingDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LoadProvingDocumentsQuery, LoadProvingDocumentsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<LoadProvingDocumentsQuery, LoadProvingDocumentsQueryVariables>(LoadProvingDocumentsDocument, baseOptions);
      };
      
export type LoadProvingDocumentsQueryHookResult = ReturnType<typeof useLoadProvingDocumentsQuery>;
export type LoadProvingDocumentsQueryResult = ApolloReactCommon.QueryResult<LoadProvingDocumentsQuery, LoadProvingDocumentsQueryVariables>;
export const AddProvingDocumentsDocument = gql`
    mutation AddProvingDocuments($provingId: String!, $input: [ProvingDocumentAdd]!) {
  addProvingDocuments(provingId: $provingId, input: $input) {
    _id
    uri
    name
    type
    participantId
  }
}
    `;
export type AddProvingDocumentsMutationFn = ApolloReactCommon.MutationFunction<AddProvingDocumentsMutation, AddProvingDocumentsMutationVariables>;

    export function useAddProvingDocumentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProvingDocumentsMutation, AddProvingDocumentsMutationVariables>) {
      return ApolloReactHooks.useMutation<AddProvingDocumentsMutation, AddProvingDocumentsMutationVariables>(AddProvingDocumentsDocument, baseOptions);
    };
export type AddProvingDocumentsMutationHookResult = ReturnType<typeof useAddProvingDocumentsMutation>;
export type AddProvingDocumentsMutationResult = ApolloReactCommon.MutationResult<AddProvingDocumentsMutation>;
export type AddProvingDocumentsMutationOptions = ApolloReactCommon.BaseMutationOptions<AddProvingDocumentsMutation, AddProvingDocumentsMutationVariables>;
export const UpdateProvingDocumentsDocument = gql`
    mutation UpdateProvingDocuments($provingId: String!, $input: [ProvingDocumentUpdate]!) {
  updateProvingDocuments(provingId: $provingId, input: $input) {
    _id
    uri
    name
    type
    block
    participantId
  }
}
    `;
export type UpdateProvingDocumentsMutationFn = ApolloReactCommon.MutationFunction<UpdateProvingDocumentsMutation, UpdateProvingDocumentsMutationVariables>;

    export function useUpdateProvingDocumentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProvingDocumentsMutation, UpdateProvingDocumentsMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateProvingDocumentsMutation, UpdateProvingDocumentsMutationVariables>(UpdateProvingDocumentsDocument, baseOptions);
    };
export type UpdateProvingDocumentsMutationHookResult = ReturnType<typeof useUpdateProvingDocumentsMutation>;
export type UpdateProvingDocumentsMutationResult = ApolloReactCommon.MutationResult<UpdateProvingDocumentsMutation>;
export type UpdateProvingDocumentsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProvingDocumentsMutation, UpdateProvingDocumentsMutationVariables>;
export const DeleteProvingDocumentsDocument = gql`
    mutation DeleteProvingDocuments($provingId: String!, $documentIds: [String!]!) {
  deleteProvingDocuments(provingId: $provingId, documentIds: $documentIds) {
    _id
  }
}
    `;
export type DeleteProvingDocumentsMutationFn = ApolloReactCommon.MutationFunction<DeleteProvingDocumentsMutation, DeleteProvingDocumentsMutationVariables>;

    export function useDeleteProvingDocumentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProvingDocumentsMutation, DeleteProvingDocumentsMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteProvingDocumentsMutation, DeleteProvingDocumentsMutationVariables>(DeleteProvingDocumentsDocument, baseOptions);
    };
export type DeleteProvingDocumentsMutationHookResult = ReturnType<typeof useDeleteProvingDocumentsMutation>;
export type DeleteProvingDocumentsMutationResult = ApolloReactCommon.MutationResult<DeleteProvingDocumentsMutation>;
export type DeleteProvingDocumentsMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProvingDocumentsMutation, DeleteProvingDocumentsMutationVariables>;